/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  ErrorContentPlugin,
  IErrorContentPluginMethods,
  ActivateUserPlugin,
  IActivateUserPluginMethods,
  DeleteUserPlugin,
  IDeleteUserPluginMethods,
  HeaderUserPlugin,
  IHeaderUserPluginMethods,
  InviteUserPlugin,
  IInviteUserPluginMethods,
  LoadingUserPlugin,
  ILoadingUserPluginMethods,
  ReInviteUserPlugin,
  IReInviteUserPluginMethods,
  SettingsUserPlugin,
  ISettingsUserPluginMethods,
  StaticUserPagePlugin,
  IStaticUserPagePluginMethods,
  UserListPlugin,
  IUserListPluginMethods,
  ISuspendUserPluginMethods,
} from './plugins';

export type TAgent = IActivateUserPluginMethods &
  IDeleteUserPluginMethods &
  IErrorContentPluginMethods &
  IHeaderUserPluginMethods &
  IInviteUserPluginMethods &
  IReInviteUserPluginMethods &
  ISettingsUserPluginMethods &
  IStaticUserPagePluginMethods &
  ISuspendUserPluginMethods &
  IUserListPluginMethods &
  ILoadingUserPluginMethods &
  IReInviteUserPluginMethods;

const getPlugins = () => {
  return [
    new StaticUserPagePlugin(),
    new ErrorContentPlugin(),
    new LoadingUserPlugin(),
    //Business logic plugins !
    new ActivateUserPlugin(),
    new DeleteUserPlugin(),
    new ErrorContentPlugin(),
    new HeaderUserPlugin(),
    new InviteUserPlugin(),
    new SettingsUserPlugin(),
    new UserListPlugin(),
    new ReInviteUserPlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
